(function () {
  function init() {
    /* Observe the whole in-flow CTA container (.ct_quantity-submit-main), NOT the submit button alone.
       The submit button is hidden (jQuery .hide()) after add-to-cart and replaced by the Go-to-Bag button
       inside the same container — if we watch the submit button it can go zero-size, causing the
       IntersectionObserver to flip the sticky bar off at the wrong moment. The container stays in flow
       at full height regardless of which child is visible, so it's a stable sentinel. */
    var bar = document.querySelector('[data-pdp-sticky-cta-row]');
    if (!bar) return;

    // The sticky CTA is the only mobile Add to Bag control and stays visible.
    bar.hidden = false;
    document.body.classList.add('pdp-sticky-cta-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
